import { useEffect, useState } from 'react'
import {
  CountryConfig,
  getCountryConfig,
  subscribeCountryConfig,
} from '../services/countryConfigService'

/** Reactive CountryConfig from Settings API (updated when settings resolve). */
export function useCountryConfig(): CountryConfig {
  const [config, setConfig] = useState<CountryConfig>(getCountryConfig())

  useEffect(() => subscribeCountryConfig(setConfig), [])

  return config
}
